import { BacksolveSourceRow } from 'api/models/BacksolveSourceRow';
import { BacksolveApproachAttributes } from 'pages/ValuationsAllocation/types';
import getCellByAlias from '../getCellByAlias';
import { getSourceRowCellKey } from '../getSourceRowKey';
import parseWeightingValue from '../parseWeightingValue';
import {
  SOURCE_ROW_DATE,
  SOURCE_ROW_PRICE,
  SOURCE_ROW_SIZE,
  SOURCE_ROW_SOURCE,
  SOURCE_ROW_TITLE,
  SOURCE_ROW_WEIGHTING,
} from '../sheetAliases';
import { CustomReverseParserParams, CustomReverseParserResult } from './types';

const customReverseParser = ({
  cells,
  tableData,
  fieldAttributes,
  allowEmptyValues,
}: CustomReverseParserParams): CustomReverseParserResult => {
  const { sourceRows } = tableData;

  const parsedRows = sourceRows.map((row, index): BacksolveSourceRow => {
    const isAutoImported = row.source_record_id !== null;
    const weightingCell = getCellByAlias(cells, getSourceRowCellKey(SOURCE_ROW_WEIGHTING, row, index));
    const weighting = parseWeightingValue(weightingCell, row.weighting, fieldAttributes, allowEmptyValues);

    if (isAutoImported) {
      // Auto-imported rows: only weighting is editable
      return {
        ...row,
        weighting,
      };
    }

    // User-provided rows: all fields are editable
    const titleCell = getCellByAlias(cells, getSourceRowCellKey(SOURCE_ROW_TITLE, row, index));
    const dateCell = getCellByAlias(cells, getSourceRowCellKey(SOURCE_ROW_DATE, row, index));
    const sourceCell = getCellByAlias(cells, getSourceRowCellKey(SOURCE_ROW_SOURCE, row, index));
    const sizeCell = getCellByAlias(cells, getSourceRowCellKey(SOURCE_ROW_SIZE, row, index));
    const priceCell = getCellByAlias(cells, getSourceRowCellKey(SOURCE_ROW_PRICE, row, index));

    return {
      ...row,
      title: String(titleCell?.value ?? row.title),
      date: dateCell?.value ? String(dateCell.value) : (row.date ?? null),
      source: String(sourceCell?.value ?? row.source ?? ''),
      size: !sizeCell || sizeCell.value === null ? (row.size ?? null) : String(sizeCell.value),
      price_per_share: String(priceCell?.value ?? row.price_per_share),
      weighting,
    };
  });

  // eslint-disable-next-line no-param-reassign
  tableData.sourceRows = parsedRows;

  return parsedRows;
};

export default customReverseParser;
